/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIAgentsObservabilityListAttributesResponse {
    getFixupPrototypeFunction() { return AIAgentsObservabilityListAttributesResponse.fixupPrototype; }

    static newInstance(model: Partial<AIAgentsObservabilityListAttributesResponse>): AIAgentsObservabilityListAttributesResponse {
        let obj = Object.assign(new AIAgentsObservabilityListAttributesResponse(), model);
        AIAgentsObservabilityListAttributesResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIAgentsObservabilityListAttributesResponse>): AIAgentsObservabilityListAttributesResponse {
        if (!model) return null;
        return AIAgentsObservabilityListAttributesResponse.newInstance(<AIAgentsObservabilityListAttributesResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIAgentsObservabilityListAttributesResponse) {
        if (!obj) return;

        models.AIAgentsObservabilityListAttributesResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIAgentsObservabilityListAttributesResponse): boolean {
        Object.setPrototypeOf(obj, AIAgentsObservabilityListAttributesResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.attributes) {
            for (let val of this.attributes) {
                models.KeyValues.fixupPrototype(val);
            }
        }
    }

    /**
     * Distinct span attribute keys and their distinct values across matched spans
     */
    attributes: Array<models.KeyValues>;

}
